var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.042c4.942 0 8.958 4.016 8.958 8.958S14.942 18.958 10 18.958 1.042 14.942 1.042 10 5.058 1.042 10 1.042zm0 1.25C5.75 2.292 2.292 5.75 2.292 10S5.75 17.708 10 17.708 17.708 14.25 17.708 10 14.25 2.292 10 2.292zm3.983 4.9a.629.629 0 010 .883L9.258 12.8a.624.624 0 01-.883 0l-2.359-2.358a.629.629 0 010-.884.629.629 0 01.884 0l1.916 1.917L13.1 7.192a.629.629 0 01.883 0z",
    fill: "var(--secondary-orange-400)"
  })));
}
export default SvgCircledTick;